import React, { useEffect } from 'react';

const AdBanner = ({ slot, format = 'auto', className = '' }) => {
  const adsenseId = process.env.REACT_APP_ADSENSE_ID;
  useEffect(() => {
    if (adsenseId && typeof window !== 'undefined' && window.adsbygoogle) {
      try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {}
    }
  }, [adsenseId]);

  if (!adsenseId) return null;

  return (
    <div className={`ad-banner ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={adsenseId}
        data-ad-slot={slot || '1234567890'}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner;
